/**
 * Returns all colors available in the `palette` of the given `theme`.
 * @param theme theme to get the colors from
 */
export var allColors = function (theme) {
  var keys = Object.keys(theme.palette);
  return keys.filter(function (key) {
    var value = theme.palette[key];
    return typeof value === 'object' && 'main' in value;
  });
};
/**
 * Maps all colors of given theme. Useful for example when writing MUI theme component `variants` for every color.
 * @param theme theme to base upon
 * @param mapper
 */
export function forAllColors(theme, mapper) {
  return allColors(theme).map(mapper);
}
/**
 * Extends theme's `palette` with `primary` and `secondary` color entries.
 * This is for compatibility with original MUI components (they rely on existence of these colors).
 * The `primary` and `secondary` colors are not intended for our use.
 */
export function addMuiPaletteCompatibility(theme) {
  theme.palette.primary = theme.palette.red;
  theme.palette.secondary = theme.palette.blue;
}